{
  "id": "campaign-130",
  "name": "Victory Bowl II",
  "seed": "campaign:130",
  "startDir": "W",
  "mowerRule": {
    "kind": "minTier",
    "tier": 0
  },
  "rows": [
    "r.....QQQQ.....r",
    "...:.......,:...",
    "...:,,a..a.,:...",
    "..a::::::::::a..",
    "................",
    ".a.a....x...a.a.",
    "....a......a....",
    "..a..a....a..a..",
    "::::::::::::::::",
    "................",
    ".....x.........~",
    "............x.~~",
    "...............~",
    "..a::::::::::a..",
    "...:~~a..a..:...",
    "...:~.......:...",
    "......QQQQ.....S"
  ],
  "critters": [
    {
      "kind": "squirrel",
      "x": 14,
      "y": 4
    },
    {
      "kind": "rabbit",
      "x": 2,
      "y": 4
    },
    {
      "kind": "squirrel",
      "x": 6,
      "y": 8
    },
    {
      "kind": "rabbit",
      "x": 11,
      "y": 9
    },
    {
      "kind": "squirrel",
      "x": 12,
      "y": 2
    }
  ],
  "pickups": [
    {
      "kind": "gas",
      "x": 8,
      "y": 14
    },
    {
      "kind": "gas",
      "x": 13,
      "y": 4
    },
    {
      "kind": "coin",
      "x": 4,
      "y": 15
    },
    {
      "kind": "coin",
      "x": 15,
      "y": 10
    },
    {
      "kind": "coin",
      "x": 15,
      "y": 11
    },
    {
      "kind": "coin",
      "x": 14,
      "y": 11
    },
    {
      "kind": "coin",
      "x": 15,
      "y": 3
    },
    {
      "kind": "coin",
      "x": 0,
      "y": 6
    },
    {
      "kind": "coin",
      "x": 9,
      "y": 11
    },
    {
      "kind": "coin",
      "x": 4,
      "y": 0
    },
    {
      "kind": "repair",
      "x": 15,
      "y": 7
    }
  ],
  "balls": {
    "first": 18,
    "every": 14
  },
  "generatorVersion": 3,
  "level": 130,
  "biome": "stadium",
  "par": {
    "reel": 8852,
    "push": 7490,
    "selfPropelled": 7224,
    "tractor": 5820,
    "zeroTurn": 4917,
    "fairway": 2971
  },
  "goldTime": {
    "reel": 8792,
    "push": 7490,
    "selfPropelled": 6924,
    "tractor": 5690,
    "zeroTurn": 4917,
    "fairway": 2933
  },
  "routeTries": {
    "par": {
      "reel": 5,
      "push": 15,
      "selfPropelled": 8,
      "tractor": 5,
      "zeroTurn": 15,
      "fairway": 13
    },
    "gold": {
      "reel": 49,
      "push": 15,
      "selfPropelled": 47,
      "tractor": 27,
      "zeroTurn": 15,
      "fairway": 49
    }
  }
}
